// Entry point for the free-tools bundle.
//
// Loaded ONLY on /free-tools/* via the `free_tools` Rails layout. Reuses the
// global posthog instance that application.js already initialised — does not
// re-init.
//
// Per-tool JavaScript is dynamic-imported from ./tools/<slug>.js so each tool
// gets its own chunk. Heavy libraries (pdf-lib, libheif-js, ZXing, UPNG, etc.)
// must be dynamic-imported inside the individual tool modules — never at this
// top level.

import { tools } from "./tools/index.js"
import { prime } from "./lib/turnstile.js"
import { trackViewed, trackCtaClicked } from "./lib/analytics.js"

function readToolMeta() {
  const root = document.getElementById("free-tool-root")
  if (!root) return null
  return {
    slug: root.dataset.toolSlug,
    category: root.dataset.toolCategory
  }
}

function wireCtaTracking(toolSlug) {
  document.querySelectorAll("[data-free-tool-cta]").forEach((el) => {
    el.addEventListener("click", () => {
      trackCtaClicked({
        toolSlug,
        location: el.dataset.freeToolCta || "unknown"
      })
    })
  })
}

async function boot() {
  const meta = readToolMeta()
  if (!meta) return // index page or non-tool page

  trackViewed({ toolSlug: meta.slug, toolCategory: meta.category })
  wireCtaTracking(meta.slug)

  const loader = tools[meta.slug]
  if (!loader) {
    // eslint-disable-next-line no-console
    console.warn(`[free-tools] no JS module registered for slug: ${meta.slug}`)
    return
  }

  const [{ init }, primeResult] = await Promise.all([
    loader(),
    prime({ toolSlug: meta.slug })
  ])

  const root = document.getElementById("free-tool-root")
  try {
    init({ root, turnstilePassed: primeResult.passed })
  } finally {
    // Clear the SSR "loading" lock — interactive controls become live now
    // that init() has wired up the drop-zone / button listeners.
    if (root) root.dataset.freeToolLoading = "false"
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true })
} else {
  boot()
}
